"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
class ConsoleLogger {
    constructor(isDebug) {
        this.isDebug = isDebug;
    }
    debug(message, ...optionalParams) {
        if (this.isDebug) {
            console.debug(message, ...optionalParams);
        }
    }
    error(message, ...optionalParams) {
        console.error(message, ...optionalParams);
    }
}
exports.ConsoleLogger = ConsoleLogger;
